import { FC, useEffect, useRef, useState } from "react";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const NewsDetailsCarousel: FC<{ newsDetails: any }> = ({ newsDetails }) => {
  const swiperRef = useRef<any>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [hasMultipleSlides, setHasMultipleSlides] = useState(false);
  useEffect(() => {
    if (newsDetails.data?.data.media?.length > 1) {
      setHasMultipleSlides(true);
    } else {
      setHasMultipleSlides(false);
    }
  }, [newsDetails.data?.data.media]);
  const handleSlideChange = () => {
    if (swiperRef.current) {
      setIsBeginning(swiperRef.current.swiper.isBeginning);
      setIsEnd(swiperRef.current.swiper.isEnd);
    }
  };
  return (
    <>


      <div className="w-full h-full flex items-center gap-3 !m-0 !p-0">
        {hasMultipleSlides && !isBeginning && (
          <span
            className="w-[32px] h-[22px] rounded-full border border-black flex items-center justify-center cursor-pointer hover:text-blue-500 hover:border-blue-500"
            onClick={() => swiperRef.current?.swiper.slidePrev()}
          >
            <LeftOutlined className="text-xs" />
          </span>
        )}

        <Swiper
          slidesPerView={1}
          modules={[Navigation]}
          ref={swiperRef}
          onSlideChange={handleSlideChange}
          onInit={handleSlideChange}
          className="w-full h-[160px] md:h-[350px] lg:h-[500px] !m-0 !p-0"
          style={{ margin: 0, padding: 0 }}
        >
          {newsDetails.data?.data.media?.map((mediaItem: any, index: number) => (
            <SwiperSlide key={index} className="group">
              <LazyLoadImage
                wrapperWidth="100%"
                wrapperHeight="100%"
                src={`${setBackEndUlr()}/${mediaItem.fullPath}`}
                style={{
                  objectFit: "contain",
                  objectPosition: "center", // Görseli sol üstten başlat

                }}
                classNames=""
                alt={`Slide ${index + 1}`}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {hasMultipleSlides && !isEnd && (
          <span
            className="w-[32px] h-[22px] rounded-full border border-black flex items-center justify-center cursor-pointer hover:text-blue-500 hover:border-blue-500"
            onClick={() => swiperRef.current?.swiper.slideNext()}
          >
            <RightOutlined className="text-xs" />
          </span>
        )}
      </div>
    </>
  );
};

export default NewsDetailsCarousel;
